import React from "react";
import classNames from "classnames";
import { Controller, useFormContext } from "react-hook-form";
import { GenericAdviserSelect, ServiceAgreementsSelect } from "./../../../components/forms/selects";
import { CurrencyInput } from "../../../components/forms";


export const CustodianCashBalancesFilterForm = ({}) => {

    const { control, setValue, watch } = useFormContext();
    
    return (
        <div className="row gy-2">
            <div className="col-6">
                <Controller
                    name="adviserIds"
                    control={control}
                    render={({ field: { ref, value, onBlur, ...rest } }) => (
                        <GenericAdviserSelect
                            label="Adviser"
                            isMulti={true}
                            defaultValue={value}
                            disableAnimations={true}
                            onBlur={(values) =>
                                setValue(
                                    "adviserIds",
                                    values.map((el) => el.value)
                                )
                            }
                        />
                    )}
                />
                </div>
                <div className="col-6">
                    <Controller
                        name="minimumBalance"
                        control={control}
                        render={({ field: { ref, value, onBlur, ...rest } }) => (
                            <CurrencyInput
                                label="Minimum Value"
                                value={value}
                                onBlur={(value) => setValue("minimumBalance", value)}   
                            />
                        )}
                />    
            </div>
        </div>
    );
};